
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Champigny-sur-Marne dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Champigny-sur-Marne certifiée Google Partner, accompagne les entreprises campinoises pour développer leur visibilité en ligne et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Champigny-sur-Marne dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Champigny-sur-Marne certifiée Google Partner, accompagne les entreprises campinoises pour développer leur visibilité en ligne et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
